import React, { useState, useEffect } from 'react';
import { ChatInterface } from '../../components/chat/ChatInterface';
import { DesignControls } from '../../components/settings/design/DesignControls';
import { MiniAppModal } from '../../components/miniapps/MiniAppModal';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Palette, Eye } from 'lucide-react';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { useSidebar } from '../../hooks/useSidebar';

export default function DesignSettings() {
  const isMobile = useMediaQuery('(max-width: 1024px)');
  const [activeTab, setActiveTab] = useState<string>("controls");
  const { isOpen, setIsOpen } = useSidebar();
  
  // Change to preview tab when going back to desktop
  useEffect(() => {
    if (!isMobile && activeTab === "preview") {
      setActiveTab("controls");
    }
  }, [isMobile, activeTab]);

  // Auto-collapse sidebar on mobile
  useEffect(() => {
    if (isMobile && isOpen) {
      setIsOpen(false);
    }
  }, [isMobile, isOpen, setIsOpen]);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-white mb-2">Design settings</h2>
        <p className="text-gray-400">Customize the appearance of your chatbot</p>
      </div>

      {isMobile ? (
        // Mobile layout with tabs
        <>
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            <TabsList className="w-full grid grid-cols-2 mb-6">
              <TabsTrigger value="controls" className="flex items-center gap-2">
                <Palette className="w-4 h-4" />
                <span>Controls</span>
              </TabsTrigger>
              <TabsTrigger value="preview" className="flex items-center gap-2">
                <Eye className="w-4 h-4" />
                <span>Preview</span>
              </TabsTrigger>
            </TabsList>
            
            <TabsContent value="controls" className="mt-0">
              <DesignControls />
            </TabsContent>
            
            <TabsContent value="preview" className="mt-0">
              <div className="bg-gray-900/50 rounded-xl border border-white/10 p-4 h-[80vh]">
                <div className="w-full h-full">
                  <ChatInterface preview />
                </div>
              </div>
            </TabsContent>
          </Tabs>
        </>
      ) : (
        // Desktop layout with side-by-side
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Colonne de gauche - Contrôles */}
          <div className="col-span-1">
            <DesignControls />
          </div>

          {/* Colonne de droite - Aperçu */}
          <div className="col-span-2">
            <div className="sticky top-24 h-[600px] bg-gray-900/50 rounded-xl border border-white/10 p-4">
              <div className="w-full h-full">
                <ChatInterface preview />
              </div>
            </div>
          </div>
        </div>
      )}

      <MiniAppModal />
    </div>
  );
}